var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBird2 = function SvgBird2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 43
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e2022",
    d: "M35.265 42.9h-1.534V27.245l-4.6.6V42.9H27.6V28.044l-19.932 2.6-6.135 6.126L0 22.981 29.131 9.192V0H46L35.264 9.192l7.666 16.854-7.666 1V42.9ZM6.133 24.513a1.532 1.532 0 1 0 1.533 1.532 1.534 1.534 0 0 0-1.533-1.532"
  })));
};
export default SvgBird2;